import { render, staticRenderFns } from "./DraftInvoicePreparer.vue?vue&type=template&id=2819181b&scoped=true&"
import script from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"
export * from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2819181b",
  null
  
)

export default component.exports